import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { PrivateRoute } from './components/auth/PrivateRoute';
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';
import { Afectaciones } from './pages/afectaciones/Afectaciones';
import { ActasCOE } from './pages/actas/ActasCOE';
import { NuevoActaCOE } from './pages/actas/NuevoAcataCOE';
import { RecursosMovilizados } from './pages/recursos/RecursosMovilizados';
import { Brechas } from './pages/brechas/Brechas';
import { CoesActivados } from './pages/coes/CoesActivados';
import { AlojamientosActivados } from './pages/alojamientos/AlojamientosActivados';
import { EntregaHumanitaria } from './pages/entrega/EntregaHumanitaria';
import { RequerimientosEnviados } from './pages/requerimientos/enviados/RequerimientosEnviados';
import { RequerimientosRecibidos } from './pages/requerimientos/recibidos/RequerimientosRecibidos';
import { NuevoRequerimientoEnviado } from './pages/requerimientos/enviados/NuevoRequerimientoEnviado';
import { NuevoRequerimientoRecibido } from './pages/requerimientos/recibidos/NuevoRequerimientoRecibido'; 
import { RequerimientosRechazados } from './pages/requerimientos/rechazados/RequerimientosRechazados';
import { NuevoRequerimientoRechazado } from './pages/requerimientos/rechazados/NuevoRequerimientoRechazado';
import { NotificationsProvider } from './context/NotificationsContext';
import { MenuProvider } from './context/MenuContext';
import { AccionesRespuestas } from './pages/acciones/AccionesRespuestas';
import { NuevoAccionesRespuesta } from './pages/acciones/NuevoAccionesRespuesta';
import EmergencySelection from './pages/EmergencySelection';
import { Eventos } from './pages/eventos/Eventos';
import { Inventario } from './pages/inventario/Inventario';
import { Barridos } from './pages/barridos/Barridos';
import { BarridosMonitoreo } from './pages/barridos_monitoreo/BarridosMonitoreo';
import { SeccionEnConstruccion } from './pages/SeccionEnConstruccion';

const App: React.FC = () => {
  return (
    <NotificationsProvider>
      <MenuProvider>
      <Routes>
      {/* Auth routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Protected application routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/emergencias" element={<EmergencySelection />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="proximamente" element={<SeccionEnConstruccion />} />
          <Route path="afectaciones" element={<Afectaciones />} />
          <Route path="inventario" element={<Inventario />} />
          <Route path="eventos" element={<Eventos />} />
          <Route path="barridos" element={<Barridos />} />
          <Route path="barridos-monitoreo" element={<BarridosMonitoreo />} />
          <Route path="barridos_monitoreo" element={<BarridosMonitoreo />} />
          <Route path="barrido_monitoreo" element={<BarridosMonitoreo />} />
          <Route path="acciones" element={<AccionesRespuestas />} />
          <Route path="acciones/nueva" element={<NuevoAccionesRespuesta />} />
          <Route path="actas" element={<ActasCOE />} />
          <Route path="actas/nueva" element={<NuevoActaCOE />} />
          <Route path="recursos" element={<RecursosMovilizados />} />
          <Route path="brechas" element={<Brechas />} />
          <Route path="coes" element={<CoesActivados />} />
          <Route path="entrada-salida" element={<AlojamientosActivados />} />
          <Route path="entrega" element={<EntregaHumanitaria />} />
          <Route path="requerimientos">
            <Route path="enviados" element={<RequerimientosEnviados />} />
            <Route path="enviados/nuevo" element={<NuevoRequerimientoEnviado />} />
            <Route path="recibidos" element={<RequerimientosRecibidos />} />
            <Route path="recibidos/nuevo" element={<NuevoRequerimientoRecibido />} />
            <Route path="rechazados" element={<RequerimientosRechazados />} />
            <Route path="rechazados/nuevo" element={<NuevoRequerimientoRechazado />} />
          </Route>
          <Route path="*" element={<Navigate to="/proximamente" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/proximamente" replace />} />
      </Route>

      {/* Fallback: if unknown route, go to login (initial screen) */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
      </MenuProvider>
    </NotificationsProvider>
  );
};

export default App;
